import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService 
{
    private currentUserSubject: BehaviorSubject<string>;
    private userLoggedIn = new Subject<string>();

    constructor() {
        this.currentUserSubject = new BehaviorSubject<string>(localStorage.getItem('rol'));
        this.userLoggedIn = this.currentUserSubject; 
    }

    
    setUserLoggedIn(rol: string) {
      this.userLoggedIn.next(rol);
   
    }

    getUserLoggedIn(): Observable<string> { return this.userLoggedIn.asObservable(); }
}
